// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/plus.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/plus'

import { Icon, type IconComponentProps } from '../icon'

export const PlusIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
